export const MAX_STR_LENGTH_FOR_CELL = 20
export const ROWS_PER_PAGE = 50
export const HIDABLE_ATTR_PREFIX ="___"